// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d4368c0","455":"38bf76ba","977":"3f0b3ffe"}[chunkId] + ".chunk.js";
};